import { FooterContainer } from './styles'

const Footer = () => {
  return (
    <FooterContainer className="FooterContainer-simples">
      <p>&copy; 2026 Lucas Torquato - Todos os direitos reservados.</p>
    </FooterContainer>
  )
}

export default Footer
